<template>
  <b-container fluid>
    <ModalExportarPresencas :id="modalPresencas" />
    <div class="tabela">
      <div class="dados">
        <h5 class="inscritos">Inscritos totais: {{ items.length }}</h5>
        <h5 class="inscritos ufla">Inscritos da UFLA: {{ inscritosUfla }}</h5>
      </div>
      <div class="botao">
        <ButtonFill
          @click="onClickExportar"
          texto="Exportar"
          class="ml-auto"
        ></ButtonFill>
        <ButtonFill
          @click="onClickExportarPresencas"
          texto="Exportar CSV de presenças"
          class="ml-auto"
        ></ButtonFill>
      </div>

      <b-table
        :items="items"
        :fields="fields"
        responsive
        caption-top
        hover
        boordeless="true"
        outlined="true"
      >
        <template v-slot:cell(studentCode)="data">{{
          data.item.studentCode || "-"
        }}</template>
      </b-table>
    </div>
  </b-container>
</template>

<script>
import { listarUsuarios, gerarCsvUsuarios } from "@/services/api/usuarios";
import ButtonFill from "@/components/Button-fill.vue";
import ModalExportarPresencas from "@/components/Admin/Usuarios/ModalExportarPresencas.vue";
import { exportarUsuarios } from "../../services/api/usuarios";
import FileHelper from "../../utils/FileHelper";

export default {
  components: {
    ButtonFill,
    ModalExportarPresencas,
  },

  data() {
    return {
      fields: [
        { label: "Nome", key: "name" },
        { label: "CPF", key: "cpf" },
        { label: "Email", key: "email" },
        { label: "LinkedIn", key: "linkedIn" },
        { label: "Estudante UFLA", key: "estudanteUfla" },
        { label: "Matrícula", key: "studentCode" },
        { label: "Curso", key: "course" },
      ],
      items: [],
      showError: false,
      textError: "",
      modalPresencas: "modal-presencas",
    };
  },
  computed: {
    inscritosUfla() {
      return this.items.filter((item) => item.estudanteUfla).length;
    },
  },
  beforeCreate() {
    listarUsuarios().then((res) => {
      this.items = res.data;
    });
  },
  methods: {
    async onClickExportar() {
      const { data } = await exportarUsuarios();

      FileHelper.salvarArquivo(data.csv, data.mimeType, data.fileName);
    },
    async onClickExportarPresencas() {
      const { data } = await gerarCsvUsuarios();

      FileHelper.salvarArquivo(data.csv, data.mimeType, data.fileName);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed");
html,
body {
  font-family: "Roboto Condensed", sans-serif;
}

.inscritos {
  display: inline;
  font-weight: 500;
}

.ufla {
  padding-left: 100px;
}

.dados {
  text-align: left;
  margin-bottom: 50px;
}

.tabela {
  padding-top: 10%;
  font-weight: 400;
  font-size: 0.9em;
  text-align: inherit;
}

.botao {
  margin-top: -110px;
  margin-left: 500px;
}
</style>
